import { FollowUpLeadsPage, FollowUpsBucketPage } from '../../components/common/LeadFollowUpViews';

export function RoleFollowUpsPage() {
  return <FollowUpsBucketPage />;
}

export function RoleFollowUpLeadsPage() {
  return <FollowUpLeadsPage />;
}
